import { OpenInNew } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { JobDetModal } from "@components/jobs/jobs-list/job-card/JobDetModal";
import { BaseModalComponent } from "../../../../../../../common/BaseModalComponent";
import { JobLayout } from "../../../../../../../jobs/jobs-list/jobs-layout/Job.layout";
import { colors } from "../../../../../../../ui/colors";
import { flownectColors } from "../../../../../const";

export const EventJobModalHeader = ({ title, jobId, job, eventUid, visitDate, compact }) => {
    const contentX = compact ? 1.25 : 2.5;
    const safeTitle = /^service\s*#/i.test(String(title || "")) ? "" : title;
    const safeAlias = /^service\s*#/i.test(String(job?.alias || "")) ? "" : job?.alias;

    const jobForDetails = {
        ...job,
        id: jobId,
        alias: safeAlias || safeTitle,
    };

    return (
        <Box
            sx={{
                position: "relative",
                background: "var(--fx-surface-base, #FFFFFF)",
                color: flownectColors.gray[900],
                px: contentX,
                py: compact ? 1 : 2,
            }}
        >
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ position: "relative", zIndex: 1 }}>
                <Box sx={{ flex: 1, minWidth: 0, mr: 2, "@container (max-width: 520px)": { mr: 1 } }}>
                    <BaseModalComponent
                        modalLabel={`Job ${jobId}`}
                        modalKey={`Calendar-Visit-Stepper-${jobId}-${eventUid || "event"}`}
                        elementTrigger={
                            <Typography
                                role="button"
                                tabIndex={0}
                                sx={{
                                    width: "fit-content",
                                    lineHeight: 1,
                                    fontSize: compact ? 13 : 14,
                                    fontWeight: 800,
                                    mb: 0.75,
                                    cursor: "pointer",
                                    color: flownectColors.gray[900],
                                    textDecoration: "none",
                                    textUnderlineOffset: "2px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 0.4,
                                    transition: "color 0.18s ease, text-decoration-color 0.18s ease",
                                    "&:hover": {
                                        color: "#2563eb",
                                        textDecoration: "underline",
                                    },
                                }}
                            >
                                {visitDate ? `Visit ${visitDate}` : "Visit"}
                                <OpenInNew sx={{ fontSize: compact ? 13 : 14, color: "currentColor", opacity: 0.75 }} />
                            </Typography>
                        }
                    >
                        <JobLayout job={jobForDetails} currentEventUid={eventUid} showCalendar />
                    </BaseModalComponent>

                    <JobDetModal
                        job={jobForDetails}
                        modalKey={`CalendarEvent-JobCard-${jobId}`}
                        wrapTrigger={false}
                        trigger={
                            <Typography
                                role="button"
                                tabIndex={0}
                                sx={{
                                    width: "fit-content",
                                    textAlign: "start",
                                    lineHeight: 1,
                                    fontSize: compact ? 12 : 12,
                                    fontWeight: 500,
                                    mb: 0.5,
                                    cursor: "pointer",
                                    color: colors.gray[400],
                                    textDecoration: "none",
                                    textUnderlineOffset: "2px",
                                    transition: "color 0.18s ease, text-decoration-color 0.18s ease",
                                    "&:hover": {
                                        color: "#2563eb",
                                        textDecoration: "underline",
                                    },
                                }}
                            >
                                Job #{jobId}
                            </Typography>
                        }
                    />
                </Box>

            </Stack>

            <Box sx={{ width: "100%", height: "1.5px", bgcolor: "#b6c0cc", mt: 1 }} />
        </Box>
    );
};
